import { app_perm_assignee_target_link_RowClass, app_perm_dfn_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class PermissionDefinitionContainerModel extends BaseContainerModel {
  permAssigneeTargetLink: app_perm_assignee_target_link_RowClass = new app_perm_assignee_target_link_RowClass();
  permDfn: app_perm_dfn_RowClass = new app_perm_dfn_RowClass();
}